// Copyright (c) StrangeBee 2024

import { useLocalMessage } from '@Helpers/locale';
import THDrawer from '@Molecules/THDrawer/THDrawer';
import React from 'react';

import './AuditDetails.scss';

interface AuditDetailsProps {
    data: any;
    visible: boolean;
    setVisible: (visible: boolean) => void;
}
export const AuditDetails = ({ data, visible, setVisible }: AuditDetailsProps) => {
    const i = useLocalMessage();

    return (
        <THDrawer
            title={i('history.drawer.title')}
            visible={visible}
            afterVisibleChange={(visible) => {
                setVisible(visible);
            }}
        >
            <div>
                <pre className="audit-details__code">
                    <code>{JSON.stringify(data, null, 2)}</code>
                </pre>
            </div>
        </THDrawer>
    );
};
